import { createSelector } from 'reselect';

import getShop from '@core/reducers/shop/selectors/getShop';

const getShopFullAddress = createSelector(getShop, shop => shop?.address || {});

export default getShopFullAddress;
